module.exports = __webpack_public_path__ + "img/RECYCLE_BIN.085a9512.svg";